import { Currency } from '@/Domain/Batch/Currency'
import { HeavyTicket } from '..'

export class HeavyTickets {
    private _tickets: HeavyTicket[]
    private _total: Currency | null

    constructor (
      tickets: HeavyTicket[],
      total: Currency | null
    ) {
      this._tickets = tickets
      this._total = total
    }

    get tickets (): HeavyTicket[] {
      return this._tickets
    }

    get total (): number {
      return this._total ? this._total.value() : 0
    }

    addTicket (ticket: HeavyTicket): void {
      this._tickets.push(ticket)
    }
}
